<template>
  <div class="extraction">
    <div id="extraction_area">
      <ExtractionBigMenu />

      <div
        style="
          display: flex;
          justify-content: space-evenly;
          width: 1080px;
          margin: auto;
          background-color: white;
          box-shadow: 0 0 1px 0 #262626;
          border-radius: 10px;
          padding-bottom: 20px;
        "
      >
        <ExtractionHoldings :params="params" />
        <ExtractionFiltre :params="params" />
      </div>
    </div>
  </div>
</template>

<script>
import ExtractionBigMenu from "@/components/extraction/ExtractionBigMenu.vue";
import ExtractionHoldings from "@/components/extraction/ExtractionHoldings.vue";
import ExtractionFiltre from "@/components/extraction/ExtractionFiltre.vue";

export default {
  name: "extraction",
  components: {
    ExtractionBigMenu,
    ExtractionHoldings,
    ExtractionFiltre,
  },
  data() {
    return {
      params: {
        type: "EXTRACTION",
        holdingName: "",
        spa: "s",
        er: "e",
        holdings: [],
        assureurs: [],
        assures_dates_start: null,
        assures_dates_end: null,
        cotisations_dates_start: null,
        cotisations_dates_end: null,
      },
    };
  },
  methods: {},
  computed: {
    extType() {
      if (this.$route.params.extType === undefined) return false;
      return this.$route.params.extType;
    },
  },
  created() {
    this.$router.push({
      name: "extraction",
      params: {
        extType: "assure",
      },
    });
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style media="screen">
div#extraction_area {
  padding: 140px 10px 0 95px;
}
</style>
